import React from 'react';
import { Lock, MapPin } from 'lucide-react';
import { useSociete } from '../context/SocieteContext';

/**
 * Bandeau affiché en mode lecture seule (plusieurs agences ou aucune agence précise sélectionnée).
 * Invite l'utilisateur à sélectionner une agence unique pour modifier les données.
 */
export function ReadOnlyBanner() {
  const { isReadOnly, activeSociete, activeAgences } = useSociete();

  if (!isReadOnly) return null;

  const isMulti = activeAgences.length > 1;
  const isNoAgence = activeSociete !== null && activeAgences.length === 0;
  const isAllSocietes = activeSociete === null;

  const message = isAllSocietes
    ? `Vue toutes sociétés — sélectionnez une agence spécifique pour créer ou modifier des données.`
    : isMulti
      ? `Vue multi-agences (${activeAgences.length} agences) — sélectionnez une seule agence pour créer ou modifier des données.`
      : isNoAgence
        ? `Vue globale de ${activeSociete?.nom} — sélectionnez une agence spécifique pour créer ou modifier des données.`
        : null;

  if (!message) return null;

  return (
    <div
      data-testid="readonly-banner"
      className="flex items-center gap-3 px-4 py-2.5 rounded-xl border text-sm"
      style={{
        background: 'var(--primary-50)',
        borderColor: 'var(--primary-100)',
        color: 'var(--primary-solid)',
      }}
    >
      <Lock size={15} style={{ flexShrink: 0 }} />
      <div className="flex items-center gap-1.5 min-w-0">
        <MapPin size={13} style={{ flexShrink: 0, opacity: 0.7 }} />
        <span style={{  }}>{message}</span>
      </div>
    </div>
  );
}
